import React from "react";
import { useCart } from "@/context/CartContext";
import { Link } from "react-router-dom";
import { Heart, Trash2 } from "lucide-react";

export default function Wishlist() {
  const { wishlist, toggleWishlist, addToCart } = useCart();
  return (
    <div className="container-x py-10" data-testid="wishlist-page">
      <h1 className="font-serif text-4xl md:text-5xl mb-8">Wishlist</h1>
      {wishlist.length === 0 ? (
        <div className="border hairline rounded-xl p-16 text-center bg-white">
          <Heart className="w-10 h-10 mx-auto gold-text" strokeWidth={1.25} />
          <div className="font-serif text-2xl mt-4">Your wishlist is empty</div>
          <Link to="/shop" className="inline-block mt-6 btn-gold rounded-full px-8 py-3 text-xs uppercase tracking-widest">Discover Products</Link>
        </div>
      ) : (
        <div className="grid md:grid-cols-2 gap-4">
          {wishlist.map((w) => (
            <div key={w.product_id} className="flex gap-4 border hairline rounded-xl p-4 bg-white">
              <img src={w.image} className="w-24 h-24 rounded object-cover" alt="" />
              <div className="flex-1">
                <Link to={`/product/${w.slug}`} className="font-serif text-lg hover:gold-text">{w.name}</Link>
                <div className="text-xs text-muted-foreground mt-1">₹{w.price}</div>
                <div className="mt-3 flex gap-2">
                  <button onClick={() => addToCart(w, 1)} className="btn-gold rounded-full px-4 py-1.5 text-xs uppercase tracking-widest" data-testid={`wl-add-${w.product_id}`}>Add to Cart</button>
                  <button onClick={() => toggleWishlist(w)} className="text-xs text-muted-foreground hover:text-destructive flex items-center gap-1"><Trash2 className="w-3.5 h-3.5" strokeWidth={1.5} /> Remove</button>
                </div>
              </div>
            </div>
          ))}
        </div>
      )}
    </div>
  );
}
